module.exports = __webpack_public_path__ + "static/media/filter.85ac7dc9.svg";